import {Civilites} from "../datas/consts";
import {ClientFormComponent} from "../common-parts/forms/client-form/client-form.component";
import {SelectClientComponent} from "../common-parts/selects/select-client/select-client.component";
import {GroupeModel} from "./groupe.model";
import {RegimeModel} from "./regime.model";
import {UserFormComponent} from "../common-parts/forms/user-form/user-form.component";

export class UserModel {
  public id: number;
  public password: string;
  public nom: string;
  public prenom: string;
  public admin: boolean;
  public email: string;
  public regime_id: RegimeModel;
  public createdAt: Date;
  public updatedAt: Date;

  constructor(maxDepth = 1) {
    maxDepth--;
    this.id = 0;
    this.password = '';
    this.nom = '';
    this.prenom = '';
    this.admin = false;
    this.email = '';
    this.regime_id = new RegimeModel();
    this.createdAt = new Date();
    this.updatedAt = new Date();
  }

  getDefaultTitle() {
    return 'Utilisateur';
  }

  getDefaultPrefixTitle() {
    return 'un';
  }

  getIndex() {
    return 'id';
  }

  getDefaultLibelleFields() {
    return ['nom', 'prenom'];
  }

  getDefaultSelectComponent() {
    return null;
  }

  getDefaultFormComponent() {
    return UserFormComponent;
  }

  getEntityUrl() {
    return 'client';
  }
}
